import React from "react";
import Container from "../helpers/Container";
import { Link } from "react-router-dom";
import "./header.scss";
import { connect } from "react-redux";
import { setDarkMode } from "../../actions";

class Header extends React.Component {
  onSliderClick = () => {
    this.props.setDarkMode();
    document.body.classList.toggle("dark");
  };

  render() {
    return (
      <React.Fragment>
        <header className="header">
          <Container>
            <nav className="navigation">
              <div className="logo__box">
                <Link to="/">
                  <img
                    src={require("../../images/desktop/logo.svg").default}
                    alt="Logo"
                  />
                </Link>
              </div>
              <div className="selector__box">
                <img
                  onClick={this.onSliderClick}
                  className="selector"
                  src={`${
                    this.props.darkMode
                      ? require("../../images/desktop/Night.svg").default
                      : require("../../images/desktop/Day.svg").default
                  }`}
                  alt="slider"
                />
              </div>
            </nav>
          </Container>
        </header>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    darkMode: state.darkMode,
  };
};

export default connect(mapStateToProps, { setDarkMode })(Header);
